import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux-immutable';
import { History } from 'history';
import languageReducer from 'containers/LanguageProvider/reducer';
import uploadDocumentsReducer from 'containers/UploadDocuments/reducers';
import appContainerReducer from 'containers/AppContainer/reducers';
import searchClaimsReducer from 'containers/IdentificationPage/reducers';
import preopenClaimReducer from 'containers/PreOpeningPage/reducers';
import statsClaimsReducer from 'containers/HomePage/reducers';
import pendingClaimsReducer from 'containers/PendingClaimsPage/reducers';
import validatedClaimsReducer from 'containers/ValidatedClaimsPage/reducers';
import rejectedClaimsReducer from 'containers/ManagerRejectedClaimsPage/reducers';
import managerPendingClaimsReducer from 'containers/ManagerPendingClaims/reducers';
import loadersReducer from 'containers/AppContainer/Loader/reducers';
import managerOpenedClaimsReducer from 'containers/ManagerOpenedClaimsPage/reducers';
import recapManagerReducer from 'containers/RecapManagerPage/reducers';
import lawyerRejectedClaimsReducer from 'containers/RejectedClaimsPage/reducers';
import existantClaimsReducer from 'containers/ManagerDocumentsPage/reducers';
import courtManagerReducer from 'containers/CourtManagerAssignedClaims/reducer';
import managerHomePageReducer from 'containers/ManagerHomePage/reducers';
import lawyerAssignmentsReducer from 'containers/LawyerAssignmentsPage/reducer';
import lawyerJudgementReducer from 'containers/LawyerLegalProceedingsPage/reducers';
import feeNoteReducer from 'containers/LawyerFeeNote/reducer';
import expertiseMissionsReducer from 'containers/CourtManagerAssignedExpertise/reducer';
import expertExpertiseReducer from 'containers/ExpertExpertise/reducers';
import ProvisionRegulationReducer from 'containers/CourtManagerLegalProceedings/Provision/redux/reducers';
import ExpertExpertiseMissionsReducer from 'containers/ExpertAssignedMissions/reducer';
import searchMissionsReducer from 'containers/ExpertHomePage/reducers';
import OpenClaimReducer from 'containers/OpeningClaimPageManager/reducer';
import attributionManagerReducer from 'containers/AttributionManager/reducer';
import preOpenManagerValidatedClaimsReducer from 'containers/PreOpenManagerValidatedClaims/reducers';
import preOpenManagerRejectedClaimsReducer from 'containers/PreOpenManagerRejectedClaims/reducers';
import PreOpenManagerPendingClaimsReducer from 'containers/PreOpenManagerPendingClaims/reducers';
import ManagerLegalProceedingsReducer from 'containers/CourtManagerLegalProceedings/reducer';
import ManagerPendingTreatementClaimsReducer from 'containers/ManagerPendingTreatementClaims/reducer';
import TransactionManagerTimeLineReducer from 'containers/TransactionManagerTimeLine/reducer';
import IntervenantManagementReducer from 'containers/IntervenantManagement/reducer';
import UploadDocumentReducer from 'containers/common/UploadDocument/reducer';
import ProvisionalClaimReducer from 'containers/ProvisionalClaimsPage/reducers';
import ProvisionalClaimDetailesReducer from 'containers/ProvisionalClaimRecap/reducers';
import usageClaimsReducer from 'containers/UsageClaimsPage/reducers';
//inject app reducers
const appReducers = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    intl: languageReducer,
    documents: uploadDocumentsReducer,
    appContainer: appContainerReducer,
    searchClaims: searchClaimsReducer,
    searchMissions: searchMissionsReducer,
    claimToPreopen: preopenClaimReducer,
    statsClaims: statsClaimsReducer,
    pendingClaims: pendingClaimsReducer,
    validatedClaims: validatedClaimsReducer,
    rejectedClaims: rejectedClaimsReducer,
    managerPendingClaims: managerPendingClaimsReducer,
    loaders: loadersReducer,
    managerOpenedClaims: managerOpenedClaimsReducer,
    recap: recapManagerReducer,
    lawyerRejectedClaims: lawyerRejectedClaimsReducer,
    existantClaims: existantClaimsReducer,
    courtManagerState: courtManagerReducer,
    managerHomePage: managerHomePageReducer,
    lawyerAssignmentsState: lawyerAssignmentsReducer,
    lawyerJudgement: lawyerJudgementReducer,
    feeNotes: feeNoteReducer,
    expertiseMissions: expertiseMissionsReducer,
    provisionRegulation: ProvisionRegulationReducer,
    expertExpertise: expertExpertiseReducer,
    expertExpertiseMissions: ExpertExpertiseMissionsReducer,
    openClaim: OpenClaimReducer,
    attributionManager: attributionManagerReducer,
    preOpenManagerValidatedClaims: preOpenManagerValidatedClaimsReducer,
    preOpenManagerRejectedClaims: preOpenManagerRejectedClaimsReducer,
    PreOpenManagerPendingClaims: PreOpenManagerPendingClaimsReducer,
    managerLegalProceedings: ManagerLegalProceedingsReducer,
    managerPendingTreatementClaims: ManagerPendingTreatementClaimsReducer,
    TransactionManagerTimeLine: TransactionManagerTimeLineReducer,
    IntervenantManagement: IntervenantManagementReducer,
    documentReducer: UploadDocumentReducer,
    provisionalClaim: ProvisionalClaimReducer,
    provisionalClaimDetails: ProvisionalClaimDetailesReducer,
    usageClaims: usageClaimsReducer,
  });
export default appReducers;
